import React from "react";
import "./footer.css";


const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container container">
        <h1 className="footer__title">Aleksej Woratsch</h1>

        <ul className="footer__list">
          <li>
            <a href="#about" className="footer__link">
              About
            </a>
          </li>

          <li>
            <a href="datenschutz.html" className="footer__link" target="_blank">
              Datenschutz
            </a>
          </li>

          <li>
            <a href="impressum.html" className="footer__link" target="_blank">
              Impressum
            </a>
          </li>
        </ul>

        <div className="footer__social">
          <a
            href="https://github.com/Awo26"
            className="footer__social-link"
            target="_blank"
          >
            <i class='bx bxl-github'></i>
          </a>

          <a
            href="https://www.linkedin.com/in/aleksej-woratsch-8b8133275/"
            className="footer__social-link"
            target="_blank"
          >
            <i class='bx bxl-linkedin-square'></i>
          </a>

         
        </div>

 
      </div>
    </footer>
  );
};

export default Footer;
